import styled from 'styled-components';
import tw, { css } from 'twin.macro';
import SVGIcon from '../SVGIcon/SVGIcon';

export const TimelineItemContainer = styled.div(({ $showTimelineAxe = true }) => [
  tw`flex items-start relative ml-16 py-8`,
  $showTimelineAxe &&
    css`
      &:before {
        content: '';
        width: 1px;
        ${tw`-z-1 -translate-x-1/2 top-0 mt-16 h-full absolute bg-silver-lighten-10`}
      }
    `
]);

export const TimelineItemBullet = styled.div(() => [
  tw`w-8 h-8 bg-silver-base shrink-0 rounded-full `
]);

export const TimelineItemBulletWrapper = styled.div(({ $containsIcon }) => [
  tw`relative shrink-0 bg-silver-lighten-30 -translate-x-1/2  flex justify-center items-center w-24 h-16 mt-2 -mr-8 rounded-full`,
  $containsIcon && tw`h-24 -mt-2`
]);

export const TimelineItemBulletIcon = styled(SVGIcon).attrs(() => ({
  size: 'medium'
}))(({ $iconColor }) => [
  $iconColor === 'red' && tw`fill-red-base`,
  $iconColor === 'blue' && tw`fill-blue-base`
]);
